module.exports = __webpack_public_path__ + "img/about-map-3.f953f73c.png";